export default function validatePassword(password = '') {
  const ret = { length: true, uppercase: true, number: true }
  ret.length = password.length >= 8
  ret.uppercase = /[A-Z]+/.test(password)
  ret.number = /[\d]+/.test(password)
  return ret
}
